import BaseService from '_services/rest/base';

class QuotationService extends BaseService {
  constructor() {
    super();
  }

  duplicate(quotationId) {
    return this.request(`${this.getUrl()}/duplicate/${quotationId}`, null, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  deleteQuotation(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getBlindsTypes() {
    return this.request(`${this.getUrl()}/blinds/types`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/quotation`;
  }

  getUrlManufacture() {
    return `${super.getUrl()}api/manufacture`;
  }

  getUrlPdf() {
    return `${super.getUrl()}api/pdf`;
  }

  getUrlProducts() {
    return `${super.getUrl()}api/product`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getList(params) {
    const filters = { search: params.search };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getPaymentTypeOptions() {
    return this.request(`${this.getUrl()}/payment-type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getProductUnits() {
    return this.request(`${this.getUrlProducts()}/units`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTypeOptions() {
    return this.request(`${this.getUrl()}/type`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getManufactureBlinds(id) {
    return this.request(`${this.getUrl()}/blinds/list/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuotationById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  print(id) {
    return this.request(`${this.getUrlPdf()}/quotation/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  printManufactureBlinds(model, id) {
    return this.request(`${this.getUrlManufacture()}/blinds/${id}`, model, 'POST', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  printWarranty(data) {
    return this.request(`${this.getUrlPdf()}/receipt`, data, 'POST', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  save(quotation) {
    const meta = this.getUrlSave(quotation.id);
    return this.request(meta.url, quotation, meta.method)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveBlinds(quotation) {
    const meta = this.getUrlSave(quotation.id, '/blinds');
    return this.request(meta.url, quotation, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveQuotationTypes(types) {
    return this.request(`${this.getUrl()}/type`, types, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  sendMessage(params) {
    return this.request(`${this.getUrl()}/${params.quotation_id}/send/email`, params, 'POST')
      .catch(err => {
        throw err;
      });
  }

  sendMessageWhats(params) {
    return this.request(`${this.getUrl()}/${params.quotation_id}/send/whatsapp`, params, 'POST')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  saveQuotationPaymentTypes(paymentTypes) {
    return this.request(`${this.getUrl()}/payment-type`, paymentTypes, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  updateStatus(quotationId, status, markAsSent = false) {
    return this.request(`${this.getUrl()}/${quotationId}/status`, { status, markAsSent }, 'PUT')
      .catch(err => {
        throw err;
      });
  }
}

export default new QuotationService();
